import { useRef } from "react";
import { Button as AntdButton } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import AttestationDeclarationSinistre from "../../../docs/AttestationDeclarationSinistre";

const DeclarationTab = ({ sinistre }) => {
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        pageStyle: `
        @page {
            size: A4 portrait !important;
            margin: 20mm;
        }
        @media print {
            html, body {
                width: 210mm;
                height: 297mm;
            }
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
    `,
        documentTitle: 'Attestation Declaration'
    });

    if (!sinistre) {
        return null;
    }

    return (
        <div className="card-body">
            <div className="container">
                <div className="grid-item">
                    <div id="attestationDeclaration">
                        <AttestationDeclarationSinistre ref={printRef} sinistre={sinistre} />
                    </div>
                </div>
            </div>
            <br />
            <AntdButton
                onClick={handlePrint}
                type="primary"
                style={{ background: "green" }}
                icon={<PrinterOutlined />}
            >
                Imprimer
                <br />
                <br />
                <br />
            </AntdButton>
        </div>
    );
};

export default DeclarationTab;
